export enum SurveyTypeEnum {
  Management = 1,
  Refurbishment,
  Demolition,
  'Re-inspection',
  Historic,
}
